import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex/store'
import 'lib-flexible'
import publicJS from './assets/js/public';
import AMap from 'vue-amap';
import VueResource from 'vue-resource';
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(publicJS);
Vue.use(AMap);
Vue.use(VueClipboard);
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  // key: 'ab5f10a7dea8cdc8bd2db88fdc29070c',
  key: '34db1971581a240a5881129ac6daac4d',
  // 插件集合 （插件按需引入）
  plugin: ['amapContainer', 'AMap.Geolocation','AMap.CitySearch']
});
// process.env.NODE_ENV = 'build';
// console.log(process.env.NODE_ENV);

const main = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

export default main;
